(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.ptBr = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Nenhum dado encontrado'
      },
      combobox: {
        placeholder: 'Selecionar',
        searchPlaceholder: 'Pesquisa'
      },
      datepicker: {
        apply: 'Aplicar',
        clearSelection: 'Desmarcar',
        pickADays: 'Selecionar dias',
        prevYear: 'Ano anterior',
        nextYear: 'Próximo ano',
        prevMonth: 'Mês anterior',
        nextMonth: 'Próximo mês',
        year: '',
        month1: 'Janeiro',
        month2: 'Fevereiro',
        month3: 'Março',
        month4: 'Abril',
        month5: 'Maio',
        month6: 'Junho',
        month7: 'Julho',
        month8: 'Agosto',
        month9: 'Setembro',
        month10: 'Outubro',
        month11: 'Novembro',
        month12: 'Dezembro',
        weeks: {
          sun: 'Dom',
          mon: 'Seg',
          tue: 'Ter',
          wed: 'Qua',
          thu: 'Qui',
          fri: 'Sex',
          sat: 'Sáb'
        },
        months: {
          jan: 'Jan',
          feb: 'Fev',
          mar: 'Mar',
          apr: 'Abr',
          may: 'Maio',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Ago',
          sep: 'Set',
          oct: 'Out',
          nov: 'Nov',
          dec: 'Dez'
        },
        pickADay: 'Selecione um dia'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Nenhum dado encontrado'
      },
      filepicker: {
        browse: 'Procurar',
        select: 'Selecione um arquivo'
      },
      filter: {
        apply: 'Aplicar',
        cancel: 'Cancelar',
        filterButton: 'Filtrar',
        reset: 'Redefinir filtros',
        resetDefault: 'Redefinir com os valores padrão'
      },
      search: {
        noDataMessage: 'Nenhum dado encontrado'
      },
      'multi-search': {
        'separator-and': 'AND',
        'search-button': 'Pesquisa',
        'search-placeholder': 'Pesquisar por nome'
      },
      select: {
        all: 'Todos',
        clearSelection: 'Limpar seleção',
        noMatch: 'Sem dados correspondentes',
        noData: 'Nenhum dado',
        placeholder: 'Selecionar',
        item: 'item(ns)',
        selected: 'selecionado',
        found: 'encontrado'
      },
      upload: {
        browseButton: 'Procurar',
        text: 'Arraste e solte os arquivos a enviar ou clique em “Procurar"',
        tip: 'Você pode carregar 10 arquivos de até 25 MB cada'
      },
      table: {
        emptyText: 'Nenhum dado'
      },
      tree: {
        emptyText: 'Nenhum dado'
      }
    }
  };
  _exports.default = _default;
});